export default __webpack_public_path__ + "static/media/adding-contact-to-list.4bf49b31.png";